module.exports = __webpack_public_path__ + "img/theme16.324df7f8.png";